(function () {
    'use strict';

    angular
        .module('invesfleet')
        .factory('preferences', preferences);

    preferences.$inject = ['$http', '$q', 'endPoints', 'authorization', '$filter'];

    function preferences($http, $q, endPoints, authorization, $filter) {

        var DEFAULT_PREFS = {
            'sectorId': 'GRU',
            'useNivel1': false,
            'labelNivel1': null,
            'typeNivel1': null,
            'useGpio1': false,
            'labelGpio1': null,
            'typeGpio1': 0,
            'useGpio3': false,
            'labelGpio3': null,
            'typeGpio3': 0,
            'useGpio4': false,
            'labelGpio4': null,
            'typeGpio4': 0
        };

        var service = {
            getCompanyPrefs: getCompanyPrefs,
            prefs : {
                companyPrefs: DEFAULT_PREFS,
                sector: companyPrefs.sectorId ? companyPrefs.sectorId : 'GRU', 
                opSates: [],
                getStateDesc: getStateDesc,
                getStateColor: getStateColor,
                getOpStateDesc: getOpStateDesc, 
                orderStates: []
            },
            loaded: false
        };

        return service;

        function getCompanyPrefs() {
            companyPrefs();
            operatorSates();
        }


        function companyPrefs(){
            var deferred = $q.defer();
            var request = {
                method: 'GET',
                url: endPoints.preferences.getCompanyPrefs
            };
            authorization.setBearerHeader($http);
			$http(request).then(function (response) {
				service.prefs.companyPrefs = response.data;
				service.prefs.sector = response.data.sectorId;
                service.loaded = true;
                deferred.resolve(response.data);
            },
            function (response) {
                service.prefs.companyPrefs = DEFAULT_PREFS;
                service.loaded = false;
                deferred.reject(null);
            });
            return deferred.promise;
        }

        function operatorSates() {
            var deferred = $q.defer();
            var request = {
                method: 'GET',
                url: endPoints.preferences.operatorSates
            };
            authorization.setBearerHeader($http);
            $http(request).then(function (response) {
                service.prefs.opSates = response.data;
                service.prefs.orderStates = [];
                angular.forEach(service.prefs.opSates, function(value, key) {
                    service.prefs.orderStates.push({id: value.operatorStateId, nombre: value.stateDescription});
                });
                service.loaded = true;
                deferred.resolve(response.data);
            },
            function (response) {
                service.prefs.opSates = [];
                service.prefs.orderStates = [];
                service.loaded = false;
                deferred.reject(null);
            });
            return deferred.promise;
        }

        function getStateDesc(id){
            if(id == null){ return null; }
            for(var i = 0; i < service.prefs.opSates.length; i++){
                var s = service.prefs.opSates[i];
				if (s.operatorStateId === id) {
					return s.stateDescription || '-';
                }
            }
            return null;
        }

        function getOpStateDesc(id) {
            if (id == null) { return null; }
            for (var i = 0; i < service.prefs.opSates.length; i++) {
                var s = service.prefs.opSates[i];
                if (s.operatorStateId === id) {
                    return s.operatorDescription || '-';
                }
            }
            return null;
        }

        function getStateColor(id) {
            if (id == null) { return null; }
            for (var i = 0; i < service.prefs.opSates.length; i++) {
                var s = service.prefs.opSates[i];
                if (s.operatorStateId === id) {
                    return s.stateColor || '';
                }
            }
            return null;
        }

    }
})();